import React, { useState, useEffect } from 'react';

const Vozila = () => {
    const [vozila, setVozila] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [formData, setFormData] = useState({ id: null, naziv: '', registracija: '' });
    const [sortConfig, setSortConfig] = useState({ key: 'naziv', direction: 'asc' });

    // KOMANDA ISPRAVLJENA: koristi HTTPS i /api/ rute
    const fetchVozila = async () => {
        try {
            const res = await fetch('https://ecopell.ledscreen.rs/api/vehicles/?t=' + new Date().getTime());
            const data = await res.json();
            setVozila(data);
            setLoading(false);
        } catch (err) { console.error("Greška pri učitavanju:", err); }
    };

    useEffect(() => { fetchVozila(); }, []);

    const sortData = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const sortedVozila = [...vozila].sort((a, b) => {
        let valA = a[sortConfig.key] || '';
        let valB = b[sortConfig.key] || '';
        if (typeof valA === 'string') valA = valA.toLowerCase();
        if (typeof valB === 'string') valB = valB.toLowerCase();
        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const isEdit = !!formData.id;
        
        // KOMANDA ISPRAVLJENA: HTTPS i ispravna putanja /api/vehicles/
        const url = isEdit 
            ? `https://ecopell.ledscreen.rs/api/vehicles/${formData.id}/`
            : 'https://ecopell.ledscreen.rs/api/vehicles/';

        try {
            const response = await fetch(url, {
                method: isEdit ? 'PUT' : 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                await fetchVozila();
                setShowModal(false);
                setFormData({ id: null, naziv: '', registracija: '' });
            }
        } catch (err) { alert("Greška pri čuvanju."); }
    };

    const handleDelete = async (id) => {
        if (window.confirm('Obrisati vozilo?')) {
            // KOMANDA ISPRAVLJENA: HTTPS
            const res = await fetch(`https://ecopell.ledscreen.rs/api/vehicles/${id}/`, { method: 'DELETE' });
            if (res.ok) fetchVozila();
        }
    };

    if (loading) return <div style={{padding: '20px', color: 'white'}}>Učitavanje...</div>;

    const commonStyle = { padding: '12px 15px', borderBottom: '1px solid #1a2a4a', boxSizing: 'border-box' };
    const thBase = { ...commonStyle, color: '#3366ff', textAlign: 'left', fontWeight: 'bold', cursor: 'pointer' };

    return (
        <div style={{padding: '20px', color: 'white'}}>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px'}}>
                <h2 style={{margin:0}}><i className="fas fa-car"></i> Vozila</h2>
                <button onClick={() => { setFormData({id:null, naziv:'', registracija:''}); setShowModal(true); }}
                        style={{backgroundColor: '#3366ff', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer'}}>
                    + Novo Vozilo
                </button>
            </div>

            <div style={{overflowX: 'auto'}}>
                <table style={{width: '100%', borderCollapse: 'collapse', backgroundColor: '#0a132b', tableLayout: 'fixed'}}>
                    <thead>
                        <tr style={{backgroundColor: '#162447'}}>
                            <th style={{...thBase, width: '80px'}} onClick={() => sortData('id')}>ID</th>
                            <th style={{...thBase, width: '40%'}} onClick={() => sortData('naziv')}>Naziv</th>
                            <th style={{...thBase, width: '40%'}} onClick={() => sortData('registracija')}>Registracija</th>
                            <th style={{...commonStyle, textAlign: 'right', color: '#3366ff', width: '120px'}}>Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sortedVozila.map(v => (
                            <tr key={v.id} style={{borderBottom: '1px solid #1a2a4a'}}>
                                <td style={commonStyle}>{v.id}</td>
                                <td style={commonStyle}>{v.naziv}</td>
                                <td style={commonStyle}>{v.registracija}</td>
                                <td style={{...commonStyle, textAlign: 'right'}}>
                                    <i className="fas fa-edit" style={{color: '#ffcc00', marginRight: '15px', cursor: 'pointer'}} 
                                       onClick={() => { setFormData(v); setShowModal(true); }}></i>
                                    <i className="fas fa-trash" style={{color: '#ff4d4d', cursor: 'pointer'}} 
                                       onClick={() => handleDelete(v.id)}></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {showModal && (
                <div style={{position: 'fixed', top:0, left:0, width:'100%', height:'100%', backgroundColor:'rgba(0,0,0,0.85)', display:'flex', justifyContent:'center', alignItems:'center', zIndex:9999}}>
                    <div style={{backgroundColor:'#0a132b', padding:'30px', borderRadius:'10px', width:'400px', border:'1px solid #3366ff'}}>
                        <h3 style={{marginTop: 0, color: 'white'}}>{formData.id ? 'Izmeni vozilo' : 'Novo vozilo'}</h3>
                        <form onSubmit={handleSubmit}>
                            <input style={inputStyle} type="text" placeholder="Naziv" value={formData.naziv} onChange={e => setFormData({...formData, naziv: e.target.value})} required />
                            <input style={inputStyle} type="text" placeholder="Registracija" value={formData.registracija} onChange={e => setFormData({...formData, registracija: e.target.value})} required />
                            <div style={{display:'flex', justifyContent:'flex-end', gap:'10px', marginTop:'20px'}}>
                                <button type="button" onClick={() => setShowModal(false)} style={{padding:'8px 15px', background:'none', color:'white', border:'1px solid #1a2a4a', cursor:'pointer'}}>Otkaži</button>
                                <button type="submit" style={{padding:'8px 15px', background:'#3366ff', color:'white', border:'none', cursor:'pointer'}}>Sačuvaj</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

const inputStyle = { width: '100%', padding: '10px', marginBottom: '15px', backgroundColor: '#050a1a', border: '1px solid #1a2a4a', color: 'white', boxSizing: 'border-box' };

export default Vozila;